import { render, staticRenderFns } from "./commerceDetail.vue?vue&type=template&id=10d5d84a&"
import script from "./commerceDetail.vue?vue&type=script&lang=js&"
export * from "./commerceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports